export default __webpack_public_path__ + "static/media/30.d336e85a.jpg";